<template>
  <p :class="variant">
    <img :src="getIcon">
    <span><slot /></span>
  </p>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    variant: {
      type: String,
      default: () => 'warning',
    },
  },
  computed: {
    getIcon () {
      return {
        warning: `${this.$root.cdnUrl}assets/icon-warning-orange.svg`,
        danger: `${this.$root.cdnUrl}assets/icon-warning-red.svg`,
      }[this.variant];
    },
  },
};

</script>

<style lang="scss" scoped>
p {
  display: flex;
  color: rgb(39, 49, 66);
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid transparent;
  align-items: center;

  img {
    margin-right: 10px;
  }
  .link {
    color: rgb(242, 122, 26);
    border-bottom: 1px solid rgb(242, 122, 26);
  }

  &.warning {
    border-color: rgb(242, 122, 26);
    background-color: rgb(253, 241, 232);
  }
  &.danger {
    border-color: rgb(255, 80, 67);
    background-color: rgb(255, 237, 236);
  }
}
</style>
